import React from "react";
import { TextField, MenuItem } from "@mui/material";

import { motion } from "framer-motion";
import { conversionFactors, formVariant } from "../../utility/constains";

const UnitSelection = ({ unit, setUnit }) => (
  <motion.div
    initial="hidden"
    animate="visible"
    custom={2}
    variants={formVariant}
  >
    <TextField
      select
      label="Land Measurement Unit"
      fullWidth
      value={unit}
      onChange={(e) => setUnit(e.target.value)}
      variant="outlined"
      InputProps={{
        className:
          "focus:ring-2 focus:ring-green-500 focus:border-green-500 hover:ring-green-600 hover:text-white",
      }}
      InputLabelProps={{
        className: "text-green-600",
      }}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            sx: {
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none",
            },
          },
        },
      }}
    >
      {Object.keys(conversionFactors).map((unitName) => (
        <MenuItem
          key={unitName}
          value={unitName}
          className="hover:bg-green-500 hover:text-green-500"
        >
          {unitName}
        </MenuItem>
      ))}
    </TextField>
  </motion.div>
);

export default UnitSelection;
